import Head from 'next/head';
import Affiliate from '../../components/Affiliate/Affiliate';

const AffiliatePage = () => {
  return (
    <>
      <Head>
        <title>Zenyai | Affiliate Program</title>
        <meta name="description" content="Join the Zenyai affiliate program and earn rewards by recommending our AI-powered audio platform" />
      </Head>
      <Affiliate />
    </>
  );
};

export default AffiliatePage; 